import { render, staticRenderFns } from "./notifyGroup.vue?vue&type=template&id=c1f16354&scoped=true&"
import script from "./notifyGroup.vue?vue&type=script&lang=js&"
export * from "./notifyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f16354",
  null
  
)

export default component.exports